// TYPES & ACTIONS
export const APPLICATION_ADD_NOTIFICATION = 'APPLICATION_ADD_NOTIFICATION'
export const APPLICATION_DUPLICATE_NOTIFICATION = 'APPLICATION_DUPLICATE_NOTIFICATION'
export const addNotification = ({ type, body, header, showIcon, dismissInSeconds } = {}) => ({
  type: APPLICATION_ADD_NOTIFICATION,
  payload: {
    key: Date.now(),
    type,
    body,
    header,
    showIcon,
    count: 1,
    dismissInSeconds,
  },
})

export const infoNotification = ({ body, header, showIcon, dismissInSeconds } = {}) =>
  addNotification({
    type: 'info',
    body,
    header,
    showIcon,
    dismissInSeconds,
  })

export const successNotification = ({ body, header, showIcon, dismissInSeconds } = {}) =>
  addNotification({
    type: 'success',
    body,
    header,
    showIcon,
    dismissInSeconds,
  })

export const warningNotification = ({ body, header, showIcon, dismissInSeconds } = {}) =>
  addNotification({
    type: 'warning',
    body,
    header,
    showIcon,
    dismissInSeconds,
  })

export const errorNotification = ({ body, header, showIcon, dismissInSeconds } = {}) =>
  addNotification({
    type: 'error',
    body,
    header,
    showIcon,
    dismissInSeconds,
  })

export const APPLICATION_DISMISS_NOTIFICATION = 'APPLICATION_DISMISS_NOTIFICATION'
export const dismissNotification = key => ({
  type: APPLICATION_DISMISS_NOTIFICATION,
  payload: {
    key,
  },
})

export const APPLICATION_TICK_NOTIFICATION_TIMER = 'APPLICATION_TICK_NOTIFICATION_TIMER'
export const tickNotificationTimer = key => ({
  type: APPLICATION_TICK_NOTIFICATION_TIMER,
  payload: {
    key,
  },
})

// SELECTORS
export const selectNotifications = state => state.application.notifications

// STATE
export const INITIAL_STATE = {}

// REDUCER
const notifications = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [APPLICATION_ADD_NOTIFICATION]: (currentState, newPayload) => {
      const lastMessage = currentState[Object.keys(currentState).pop()]
      if (lastMessage?.body && lastMessage.body === newPayload.body) {
        return {
          ...currentState,
          [lastMessage.key]: {
            ...lastMessage,
            count: lastMessage.count + 1,
            dismissInSeconds: newPayload.dismissInSeconds,
          },
        }
      }
      return {
        ...currentState,
        [newPayload.key]: { ...newPayload },
      }
    },
    [APPLICATION_DISMISS_NOTIFICATION]: (currentState, newPayload) => {
      const { [newPayload.key]: _, ...remainingNotifications } = currentState
      return {
        ...remainingNotifications,
      }
    },
    [APPLICATION_TICK_NOTIFICATION_TIMER]: (currentState, newPayload) => {
      const notification = { ...currentState[newPayload.key] }
      return {
        ...currentState,
        [newPayload.key]: {
          ...notification,
          dismissInSeconds: notification.dismissInSeconds - 1,
        },
      }
    },
  }[type]?.(state, payload) || state)

export default notifications
